"use client";
import { j as s } from "./jsx-runtime-CJ-St4mQ.mjs";
import { b as o } from "./List.style-BO8Br8D6.mjs";
import a from "./Box.js";
function l(t) {
  const { className: e, children: r, ...m } = t;
  return /* @__PURE__ */ s.jsx(
    a,
    {
      render: /* @__PURE__ */ s.jsx("span", {}),
      className: o({
        class: e
      }),
      children: r
    }
  );
}
export {
  l as ListItemIcon,
  l as default
};
